<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        style="max-width:36px !important"
        icon
        @click.stop=""
        v-on="on"
      >
        <v-icon color="hrissecondary">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Company Banks"
      text="Create Company Bank"
      class="mb-0"
      :loading="loading"
    > 
      <form v-if="!loading">
        <v-container
          class="overflow"
          data-simplebar
        >
          <v-row no-gutters>
            <v-col cols="12">
              <v-autocomplete
                v-model="payrollBankId"
                v-validate="'required'"
                :items="payrollBanks"
                :error-messages="errors.collect('payrollBankId')"
                data-vv-name="payrollBankId"
                data-vv-as="bank" 
                item-text="name"
                item-value="id"
                value="id"
                label="Company Bank"
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="bankAccountNo"
                v-validate="bankValidate(payrollBankId)"
                :error-messages="errors.collect('bankAccountNo')"
                data-vv-name="bankAccountNo"
                :data-vv-as="payrollBankId === 19?'originator account no.' :'bank account no.'" 
                :label="payrollBankId === 19? 'Originator Account No':'Account No.'"
              />
            </v-col>

            <v-col
              v-show="payrollBankId === 25"
              cols="12"
            >
              <v-text-field
                v-model="corporateId"
                v-validate="'length:6'"
                :error-messages="errors.collect('corporateId')"
                data-vv-name="corporateId"
                data-vv-as="corporate ID"
                label="REFLEX Corporate ID"
                type="number"
                @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
              />
            </v-col>

            <v-col
              v-show="payrollBankId === 19"
              cols="12"
            >
              <v-text-field
                v-model="companyRegisterId"
                v-validate="companyRegisteredIdValidate(payrollBankId)"
                label="Company ID in Maybank Autocredit System (MAS)"
                :error-messages="errors.collect('companyRegisterId')"
                data-vv-name="companyRegisterId"
                data-vv-as="company ID in MAS"
              />
            </v-col>

            <v-col
              v-show="payrollBankId === 19 || payrollBankId === 5"
              cols="12"
            >
              <v-text-field
                v-model="originatorId"
                v-validate="originatorIdValidate(payrollBankId)"
                :error-messages="errors.collect('originatorId')"
                data-vv-name="originatorId"
                :data-vv-as="payrollBankId === 5?'organisation code' :'originator id'"
                :label="payrollBankId === 5?'Organisation Code' :'Originator ID'"
              />
            </v-col>

            <v-col
              v-show="payrollBankId === 19"
              cols="12"
            >
              <v-text-field
                v-model="originatorShortName"
                v-validate="shortNameValidate(payrollBankId)"
                label="Originator Short Name"
                :error-messages="errors.collect('originatorShortName')"
                data-vv-name="originatorShortName"
                data-vv-as="originator short name"
              />
            </v-col>

            <v-col cols="12">
              <span> Is Default? </span>
              <v-radio-group
                v-model="isDefault"
                v-validate="'required'"
                :error-messages="errors.collect('isDefault')"
                data-vv-name="isDefault"        
                data-vv-as="is default"        
                row
              >
                <v-radio
                  label="No"
                  :value="0"
                />
                <v-radio
                  label="Yes"
                  :value="1"
                /> 
              </v-radio-group>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions v-if="!loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"  
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyId: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: false,
        payrollBanks: [],
        payrollBankId: null,
        bankAccountNo: null,
        isDefault: 0,
        originatorId: null,
        companyRegisterId: null,
        corporateId: null,
        originatorShortName: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return       

        this.loading = true
        this.resetForm()

        this.$api.payrollBanks().list()
          .then((res) => {
            this.payrollBanks = res.data.filter(data => {
              return [19, 5, 25, 23].includes(data.id)
            })
            
            this.loading = false
          })
      },
    },
    methods: {
      bankValidate (id) {
        if (!id) return 'required'
        if (id === 19) return 'required|max:12' // maybank
        return 'required'
      },

      originatorIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:5' // maybank
        if (id === 5) return 'required|max:10' // ambb
        return ''
      },

      companyRegisteredIdValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:3' // maybank
        return ''
      },

      shortNameValidate (id) {
        if (!id) return ''
        if (id === 19) return 'required|max:13' // maybank
        return ''
      },
      
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.companyBanks().create(this.prepareFormData())
              .then((res) => {
                this.$emit('created')            
                this.$snack({ message: 'Added new company banks' })

                this.progressing = false
                this.dialog = false        
              })
              .catch((err) => {
                if (err.response.status === 405) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          company_id: this.companyId,
          payroll_bank_id: this.payrollBankId,
          bank_account_no: this.bankAccountNo,
          is_default: this.isDefault,
          originator_id: this.originatorId,
          short_name: this.originatorShortName,
          company_registered_id: this.companyRegisterId,
          corporate_id: this.corporateId,
        }
      }, 

      resetForm () {
        this.$validator.reset()
        this.bankAccountNo = null
        this.corporateId = null
        this.payrollBankId = null
        this.originatorId = null
        this.originatorShortName = null
        this.companyRegisterId = null
        this.isDefault = 0
      },
    },
  }
</script>
